<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_6">FOR STAN:<br/>I MISS YOU EVERY DAY</a></p><a id="page_6">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 003_Dedication.vue?2e39cfa2